import {EntityModel} from "@fedeltapointofsale/data-client";
import {CreditCardMappingData} from "./credit-card-mapping.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class CreditCardMappingEntityModel extends EntityModel<CreditCardMappingData> {
    constructor(injector: Injector) {
        super(injector, CreditCardMappingData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
